import React, { useEffect, useState } from 'react';
import './MainHome.scss';
import MidSearch from '../MidSearch/MidSearch';
import SignInPopupHOC from '../../../pages/Login/hoc/SigninHoc';
import SignUpPopupHOC from '../../../pages/SignUp/hoc/SignupHoc';
import SignIn from '../../../pages/Login/Signin';
import SignUp from '../../../pages/SignUp/Signup';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { loggedInUserState } from '../../../redux/slices/LoginSlice';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

// Interface for dynamic offer structure
interface IOfferConfig {
  id: string;
  isActive: boolean;
  text: string;
  badgeText?: string;
  modalTitle: string;
  steps: string[];
}

function MainHome(props: any) {
  const {
    signInToggleHandler,
    showSignInPopup,
    signUpToggleHandler,
    showSignUpPopup,
  } = props;

  const [locationName, setLocationName] = useState('India');
  const navigate = useNavigate();

  // Offer Banner State
  const [showOfferBanner, setShowOfferBanner] = useState(true);
  const [showOfferModal, setShowOfferModal] = useState(false);
  const userData = useSelector(loggedInUserState);
  const isLoggedIn = Boolean(userData);

  // Dynamic Offer Configuration (Can be replaced with an API call)
  const offerConfig: IOfferConfig = {
    id: 'zomato_500_v1',
    isActive: true,
    badgeText: 'LIMITED OFFER',
    text: 'Get a chance to win ₹500 Zomato Voucher! Click here to see how.',
    modalTitle: 'How to Claim Your ₹500 Zomato Voucher',
    steps: [
      'Sign up or log in to your GrhamDeal account.',
      'List a new property (Flat, PG, House, or Room).',
      'Keep your property listing active and verified.',
      'Once your listing is verified, you will be eligible to receive a Zomato voucher.',
    ],
  };

  useEffect(() => {
    if (!navigator.geolocation) {
      setLocationName('India');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
          );

          if (!response.ok) {
            throw new Error('Reverse geocoding failed');
          }

          const data = await response.json();
          const resolvedLocation =
            data?.address?.city ||
            data?.address?.town ||
            data?.address?.village ||
            data?.address?.state ||
            data?.address?.country ||
            'India';

          setLocationName(resolvedLocation);
        } catch (error) {
          setLocationName('India');
        }
      },
      () => {
        setLocationName('India');
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 600000,
      }
    );
  }, []);

  return (
    <>
      {showSignInPopup && (
        <SignIn
          modalClosedSignIn={signInToggleHandler}
          modalClosedSignUp={signUpToggleHandler}
        />
      )}

      {showSignUpPopup && (
        <SignUp
          modalClosedSignUp={signUpToggleHandler}
          modalClosedSignIn={signInToggleHandler}
        />
      )}

      {/* Dynamic Offer Modal */}
      {showOfferModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}
          tabIndex={-1}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fw-bold text-primary">
                  {offerConfig.modalTitle}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowOfferModal(false)}
                ></button>
              </div>
              <div className="modal-body p-4">
                <p className="mb-3 text-muted">
                  Complete these simple steps to claim your reward:
                </p>
                <ul className="list-group list-group-numbered mb-3">
                  {offerConfig.steps.map((step, idx) => (
                    <li key={idx} className="list-group-item">
                      {step}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="modal-footer">
                {!isLoggedIn ? (
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setShowOfferModal(false);
                      signUpToggleHandler();
                    }}
                  >
                    Get Started / Sign Up
                  </button>
                ) : (
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setShowOfferModal(false);
                      navigate('/dashboard');
                    }}
                  >
                    Go to Dashboard
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowOfferModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Dynamic Offer Banner */}
      {offerConfig.isActive && showOfferBanner && (
        <div className="bg-warning text-dark px-3 py-2 text-center d-flex align-items-center justify-content-between">
          <div
            className="w-100 text-center style-cursor-pointer"
            onClick={() => setShowOfferModal(true)}
            style={{ cursor: 'pointer' }}
          >
            {offerConfig.badgeText && (
              <span className="badge bg-danger me-2">
                {offerConfig.badgeText}
              </span>
            )}
            <span className="fw-bold">{offerConfig.text}</span>
          </div>
          <button
            type="button"
            className="btn-close btn-close-sm ms-2"
            aria-label="Close banner"
            onClick={(e) => {
              e.stopPropagation();
              setShowOfferBanner(false);
            }}
          ></button>
        </div>
      )}

      <div className="home-hero blur-bg">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-2 animate__animated animate__fadeInDown">
              <h1>Find Rooms, Flats & Houses for Rent in {locationName}</h1>

              <p className="home-hero-subtitle">
                GrhamDeal helps you find ready-to-move rental homes and connect
                directly with property owners.
              </p>
            </div>
            <div className="col-12 animate__animated animate__fadeInLeft">
              <MidSearch signInToggleHandler={signInToggleHandler} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignUpPopupHOC(SignInPopupHOC(MainHome));
